<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="cancelar"
      :custom-footer-style="'position: fixed;bottom: 0px;right: 0px;background-color: var(--card-bg);width: 100%'"
    >
      <template slot="conteudo">
        <b-row
          v-if="abaAcessada == 0"
          no-gutters
        >
          <b-col class="text-right">
            <dropdown-tag
              ref="tagProposta"
              :tags="tagsProposta"
              grupo-tags="Proposta"
              legenda="Tag Proposta"
              @enviar-pai="addTagTemplate"
            />

            <!-- BOTÃO PDF (laranja/vermelho) -->
            <b-btn
              size="sm"
              class="btn-outline-success"
              :style="{
                marginRight: '0.25rem',
                backgroundColor: '#ff6b3d',
                borderColor: '#ff6b3d',
                color: '#fff'
              }"
              @click="$refs.fileInputPdf.click()"
            >
              <font-awesome-icon
                :icon="faFileUpload"
                style="font-size:15px !important;width:20px"
              /> Importar .pdf
            </b-btn>

            <!-- BOTÃO DOCX -->
            <b-btn
              size="sm"
              variant="info"
              class="btn-outline-success"
              style="margin-right:0.25rem"
              @click="$refs.fileInput.click()"
            >
              <font-awesome-icon
                :icon="faFileUpload"
                style="font-size:15px !important;width:20px"
              /> Importar .docx
            </b-btn>

            <!-- BOTÃO IMPRIMIR -->
            <b-btn
              id="imprimir-documento"
              size="sm"
              variant="primary"
              class="btn-outline-success"
              style="margin-right:0.25rem"
              @click="imprimir"
            >
              <font-awesome-icon
                :icon="faPrint"
                style="font-size:15px !important;width:20px"
              />Imprimir</b-btn>
          </b-col>
        </b-row>

        <b-tabs
          card
          @input="alterandoAba"
        >
          <b-tab
            ref="geral"
            no-body
            title="Editor de Texto"
          >
            <div v-if="abaAcessada == 0">
              <b-row>
                <b-col>
                  <fieldset class="font-weight-bold text-muted small">
                    Aqui você configura o template da proposta utilizando as ferramentas disponíveis no editor de texto.
                  </fieldset>
                </b-col>
                <b-col cols="12">
                  <hr
                    class="mx-0 mt-0 mb-2"
                    style="border-top: 1px solid #a3a4a66b !important;"
                  >
                </b-col>
                <b-col cols="12">
                  <editor
                    ref="tinymceEditor"
                    v-model="form.template"
                    api-key="rw08hrnrxbws6bwi1g8vajfilhyq7tr75s79uq8sp49np6h0"
                    :init="tinymceInit"
                    style="padding-bottom: 5%;"
                  />
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <b-tab
            no-body
            title="Perfil do Template"
          >
            <aba-parametrizacao
              v-if="abaAcessada == 1"
              ref="parametrizacao"
              titulo="Perfil do template"
              descricao="Aqui você parametriza o perfil do template, através desses dados é feito o vínculo com a proposta de forma automática"
              :value="form"
            />
          </b-tab>
        </b-tabs>

        <b-modal
          ref="modalUsuarioDocusign"
          size="sm"
        >
          <legend class="col-form-label pt-0">
            Selecione o usuário</legend>
          <b-select
            v-model="selecionado"
            :options="usuariosFiltrado"
            text-field="nomeCompleto"
            value-field="id"
          />
          <template #modal-footer>
            <b-btn
              variant="primary"
              class="btn btn-sm"
              :disabled="!selecionado"
              @click="setUsuarioTag"
            >
              Confirmar
            </b-btn>
          </template>
        </b-modal>

        <!-- INPUT DOCX -->
        <input
          ref="fileInput"
          type="file"
          style="display: none"
          accept=".docx"
          @change="handleDocxUpload"
        >

        <!-- INPUT PDF -->
        <input
          ref="fileInputPdf"
          type="file"
          style="display: none"
          accept=".pdf"
          @change="handlePdfUpload"
        >
      </template>
    </cadastro-base>
  </div>
</template>

<style lang="scss">
.card-header {
  padding-bottom: 0px !important;
}
</style>

<script>
import Editor from '@tinymce/tinymce-vue'
import mammoth from 'mammoth'

import {
  required,
} from '@validations'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faPrint,
  faTags,
  faFileUpload,
} from '@fortawesome/free-solid-svg-icons'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import AbaParametrizacao from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplateProposta/components/cadatro-parametrizacao/CadastroParametrizacaoProposta.vue'
import api from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplateProposta/services/api'
import apiUsuarioInterno from '@/app-modulo/comuns/usuario-interno/shared/services/api'

export default {
  name: 'CadastroTemplateProposta',
  components: {
    Editor,
    CadastroBase,
    AbaParametrizacao,
    FontAwesomeIcon,
    DropdownTag: () => import('@/shared/components/dropdown-tag/DropdownTag.vue'),
  },
  data() {
    return {
      faPrint,
      faTags,
      faFileUpload,
      required,
      form: {
        template: '',
      },
      abaAcessada: 0,
      templateOptions: [
        { value: 'proposta', text: 'Proposta' },
      ],
      propostaOptions: [
        { value: 'constituicao', text: 'Proposta honorários empresas em constituição' },
        { value: 'transeferencia', text: 'Proposta honorários empresas em transferência' },
      ],
      tagsProposta: ['Servicos - Sem Preço', 'Servicos - Com Descrição'],
      usuarios: [],
      usuariosFiltrado: [],
      tagAtual: '',
      selecionado: null,
      pdfFile: null,

      tinymceInit: {
        plugins: 'lists advlist link image code table wordcount autolink anchor searchreplace visualblocks fullscreen media template',
        toolbar: 'undo redo | formatselect | bold italic backcolor | '
          + 'alignleft aligncenter alignright alignjustify | '
          + 'bullist numlist outdent indent | removeformat | '
          + 'link image media table | template | code fullscreen',

        menubar: true,
        min_height: 300,
        max_height: 700,
        entity_encoding: 'raw',
        forced_root_block: false,

        // CSS externo do iframe
        content_css: ['/css/proposta-layout.css'],

        // 9 templates – TODOS com wrapper externo em branco
        templates: [
          {
            title: 'Layout 1 – Pacotes (A4 Vertical)',
            description: 'Página A4 vertical com 3 planos: Básico, Profissional (destaque) e Ultimate',
            content: `
              <div class="a4-page a4-vertical" style="background:#ffffff;">
                <div class="pricing-layout">
                  <div class="pricing-card">
                    <div class="pricing-card-inner">
                      <div class="pricing-card-header">
                        <div class="pricing-card-header-left">
                          <span class="pricing-card-icon">🔥</span>
                          <h2 class="pricing-card-title" contenteditable="true">Pacote Básico</h2>
                          <div class="pricing-card-subtitle" contenteditable="true">Descrição/resumo do pacote básico</div>
                        </div>
                        <div class="pricing-card-rate-block">
                          <div class="pricing-card-rate" contenteditable="true">R$ 0,00</div>
                          <div class="pricing-card-rate-period" contenteditable="true">por mês</div>
                        </div>
                      </div>

                      <ul class="pricing-card-benefits">
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 1</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 2</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 3</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 4</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 5</span></li>
                      </ul>

                      <div class="pricing-card-divider"></div>
                    </div>
                  </div>

                  <div class="pricing-card highlight">
                    <div class="pricing-card-inner">
                      <div class="pricing-card-header">
                        <div class="pricing-card-header-left">
                          <span class="pricing-card-icon">⚡</span>
                          <h2 class="pricing-card-title" contenteditable="true">Pacote Profissional</h2>
                          <div class="pricing-card-subtitle" contenteditable="true">Descrição/resumo do pacote profissional</div>
                        </div>
                        <div class="pricing-card-rate-block">
                          <div class="pricing-card-rate" contenteditable="true">R$ 0,00</div>
                          <div class="pricing-card-rate-period" contenteditable="true">por mês</div>
                        </div>
                      </div>

                      <ul class="pricing-card-benefits">
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 1</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 2</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 3</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 4</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 5</span></li>
                      </ul>

                      <div class="pricing-card-divider"></div>
                    </div>
                  </div>

                  <div class="pricing-card">
                    <div class="pricing-card-inner">
                      <div class="pricing-card-header">
                        <div class="pricing-card-header-left">
                          <span class="pricing-card-icon">💎</span>
                          <h2 class="pricing-card-title" contenteditable="true">Pacote Ultimate</h2>
                          <div class="pricing-card-subtitle" contenteditable="true">Descrição/resumo do pacote ultimate</div>
                        </div>
                        <div class="pricing-card-rate-block">
                          <div class="pricing-card-rate" contenteditable="true">R$ 0,00</div>
                          <div class="pricing-card-rate-period" contenteditable="true">por mês</div>
                        </div>
                      </div>

                      <ul class="pricing-card-benefits">
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 1</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 2</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 3</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 4</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 5</span></li>
                      </ul>

                      <div class="pricing-card-divider"></div>
                    </div>
                  </div>
                </div>
              </div>
            `,
          },
          {
            title: 'Layout 2 – Pacotes (A4 Horizontal)',
            description: 'Página A4 horizontal com 3 planos: Básico, Profissional (destaque) e Ultimate',
            content: `
              <div class="a4-page a4-horizontal" style="background:#ffffff;">
                <div class="pricing-layout">
                  <div class="pricing-card">
                    <div class="pricing-card-inner">
                      <div class="pricing-card-header">
                        <div class="pricing-card-header-left">
                          <span class="pricing-card-icon">🔥</span>
                          <h2 class="pricing-card-title" contenteditable="true">Pacote Básico</h2>
                          <div class="pricing-card-subtitle" contenteditable="true">Descrição/resumo do pacote básico</div>
                        </div>
                        <div class="pricing-card-rate-block">
                          <div class="pricing-card-rate" contenteditable="true">R$ 0,00</div>
                          <div class="pricing-card-rate-period" contenteditable="true">por mês</div>
                        </div>
                      </div>

                      <ul class="pricing-card-benefits">
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 1</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 2</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 3</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 4</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 5</span></li>
                      </ul>

                      <div class="pricing-card-divider"></div>
                    </div>
                  </div>

                  <div class="pricing-card highlight">
                    <div class="pricing-card-inner">
                      <div class="pricing-card-header">
                        <div class="pricing-card-header-left">
                          <span class="pricing-card-icon">⚡</span>
                          <h2 class="pricing-card-title" contenteditable="true">Pacote Profissional</h2>
                          <div class="pricing-card-subtitle" contenteditable="true">Descrição/resumo do pacote profissional</div>
                        </div>
                        <div class="pricing-card-rate-block">
                          <div class="pricing-card-rate" contenteditable="true">R$ 0,00</div>
                          <div class="pricing-card-rate-period" contenteditable="true">por mês</div>
                        </div>
                      </div>

                      <ul class="pricing-card-benefits">
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 1</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 2</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 3</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 4</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 5</span></li>
                      </ul>

                      <div class="pricing-card-divider"></div>
                    </div>
                  </div>

                  <div class="pricing-card">
                    <div class="pricing-card-inner">
                      <div class="pricing-card-header">
                        <div class="pricing-card-header-left">
                          <span class="pricing-card-icon">💎</span>
                          <h2 class="pricing-card-title" contenteditable="true">Pacote Ultimate</h2>
                          <div class="pricing-card-subtitle" contenteditable="true">Descrição/resumo do pacote ultimate</div>
                        </div>
                        <div class="pricing-card-rate-block">
                          <div class="pricing-card-rate" contenteditable="true">R$ 0,00</div>
                          <div class="pricing-card-rate-period" contenteditable="true">por mês</div>
                        </div>
                      </div>

                      <ul class="pricing-card-benefits">
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 1</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 2</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 3</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 4</span></li>
                        <li><span class="pricing-card-check-icon"></span><span contenteditable="true">Benefício 5</span></li>
                      </ul>

                      <div class="pricing-card-divider"></div>
                    </div>
                  </div>
                </div>
              </div>
            `,
          },
          {
            title: 'Layout 3 – Cards Fogo Azul',
            description: '3 cards verticais com ícone de fogo e lista de benefícios',
            content: `
              <div class="layout-wrapper" style="background:#ffffff;">
                <div class="pricing-fire-wrapper" style="background:#ffffff;">
                  <div class="fire-card">
                    <div class="fire-card-header">
                      <div class="fire-card-header-left">
                        <div class="fire-card-logo">🔥</div>
                        <div class="fire-card-plan" contenteditable="true">BASIC</div>
                        <div class="fire-card-title" contenteditable="true">Nome do pacote</div>
                      </div>
                      <div class="fire-card-price" contenteditable="true">
                        R$ 57
                        <span>/mês</span>
                      </div>
                    </div>

                    <ul class="fire-card-benefits">
                      <li><span class="fire-card-check"></span><span contenteditable="true">Benefício 1</span></li>
                      <li><span class="fire-card-check"></span><span contenteditable="true">Benefício 2</span></li>
                      <li><span class="fire-card-check"></span><span contenteditable="true">Benefício 3</span></li>
                      <li><span class="fire-card-check"></span><span contenteditable="true">Benefício 4</span></li>
                    </ul>

                    <div class="fire-card-footer" contenteditable="true">
                      Observação / chamada
                    </div>
                  </div>

                  <div class="fire-card highlight">
                    <div class="fire-card-header">
                      <div class="fire-card-header-left">
                        <div class="fire-card-logo">🔥</div>
                        <div class="fire-card-plan" contenteditable="true">STANDARD</div>
                        <div class="fire-card-title" contenteditable="true">Nome do pacote</div>
                      </div>
                      <div class="fire-card-price" contenteditable="true">
                        R$ 70
                        <span>/mês</span>
                      </div>
                    </div>

                    <ul class="fire-card-benefits">
                      <li><span class="fire-card-check"></span><span contenteditable="true">Benefício 1</span></li>
                      <li><span class="fire-card-check"></span><span contenteditable="true">Benefício 2</span></li>
                      <li><span class="fire-card-check"></span><span contenteditable="true">Benefício 3</span></li>
                      <li><span class="fire-card-check"></span><span contenteditable="true">Benefício 4</span></li>
                    </ul>

                    <div class="fire-card-footer" contenteditable="true">
                      Observação / chamada
                    </div>
                  </div>

                  <div class="fire-card">
                    <div class="fire-card-header">
                      <div class="fire-card-header-left">
                        <div class="fire-card-logo">🔥</div>
                        <div class="fire-card-plan" contenteditable="true">PREMIUM</div>
                        <div class="fire-card-title" contenteditable="true">Nome do pacote</div>
                      </div>
                      <div class="fire-card-price" contenteditable="true">
                        R$ 82
                        <span>/mês</span>
                      </div>
                    </div>

                    <ul class="fire-card-benefits">
                      <li><span class="fire-card-check"></span><span contenteditable="true">Benefício 1</span></li>
                      <li><span class="fire-card-check"></span><span contenteditable="true">Benefício 2</span></li>
                      <li><span class="fire-card-check"></span><span contenteditable="true">Benefício 3</span></li>
                      <li><span class="fire-card-check"></span><span contenteditable="true">Benefício 4</span></li>
                    </ul>

                    <div class="fire-card-footer" contenteditable="true">
                      Observação / chamada
                    </div>
                  </div>

                </div>
              </div>
            `,
          },
          {
            title: 'Layout 4 – Pricing Cards Azul Escuro',
            description: '3 cards verticais em azul escuro (Basic / Standard / Premium)',
            content: `
              <div class="layout-wrapper pricing-modern-bg" style="background:#ffffff;">
                <div class="pricing-modern-wrapper" style="background:#ffffff;">
                  <div class="pricing-modern-card basic-blue">
                    <div class="pricing-modern-plan-label" contenteditable="true">BASIC</div>
                    <div class="pricing-modern-price-main">
                      <span contenteditable="true">$</span><span contenteditable="true">57</span>
                    </div>
                    <div class="pricing-modern-price-period" contenteditable="true">
                      $ 681/yr
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      LIABILITY
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 125,000</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      PERSONAL PROPERTY
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 134,343</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      MEDICAL
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 1,500</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-footer-link" contenteditable="true">
                      FIND AN AGENT
                    </div>
                    <button class="pricing-modern-cta" contenteditable="true">
                      BUY
                    </button>
                  </div>

                  <div class="pricing-modern-card standard-blue">
                    <div class="pricing-modern-plan-label" contenteditable="true">STANDARD</div>
                    <div class="pricing-modern-price-main">
                      <span contenteditable="true">$</span><span contenteditable="true">70</span>
                    </div>
                    <div class="pricing-modern-price-period" contenteditable="true">
                      $ 834/yr
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      LIABILITY
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 4,55,000</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      PERSONAL PROPERTY
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 150,500</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      MEDICAL
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 1,600</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-footer-link" contenteditable="true">
                      FIND AN AGENT
                    </div>
                    <button class="pricing-modern-cta" contenteditable="true">
                      BUY
                    </button>
                  </div>

                  <div class="pricing-modern-card premium-blue">
                    <div class="pricing-modern-plan-label" contenteditable="true">PREMIUM</div>
                    <div class="pricing-modern-price-main">
                      <span contenteditable="true">$</span><span contenteditable="true">82</span>
                    </div>
                    <div class="pricing-modern-price-period" contenteditable="true">
                      $ 979/yr
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      LIABILITY
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 1,43,000</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      PERSONAL PROPERTY
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 175,200</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      MEDICAL
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 1,900</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-footer-link" contenteditable="true">
                      FIND AN AGENT
                    </div>
                    <button class="pricing-modern-cta" contenteditable="true">
                      BUY
                    </button>
                  </div>

                </div>
              </div>
            `,
          },
          {
            title: 'Layout 5 – Pricing Cards Verde',
            description: 'Variação em verde do layout de Pricing Azul Escuro',
            content: `
              <div class="layout-wrapper pricing-modern-bg-green" style="background:#ffffff;">
                <div class="pricing-modern-wrapper" style="background:#ffffff;">
                  <div class="pricing-modern-card basic-green">
                    <div class="pricing-modern-plan-label" contenteditable="true">BASIC</div>
                    <div class="pricing-modern-price-main">
                      <span contenteditable="true">$</span><span contenteditable="true">57</span>
                    </div>
                    <div class="pricing-modern-price-period" contenteditable="true">
                      $ 681/yr
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      LIABILITY
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 125,000</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      PERSONAL PROPERTY
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 134,343</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      MEDICAL
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 1,500</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-footer-link" contenteditable="true">
                      FIND AN AGENT
                    </div>
                    <button class="pricing-modern-cta" contenteditable="true">
                      BUY
                    </button>
                  </div>

                  <div class="pricing-modern-card standard-green">
                    <div class="pricing-modern-plan-label" contenteditable="true">STANDARD</div>
                    <div class="pricing-modern-price-main">
                      <span contenteditable="true">$</span><span contenteditable="true">70</span>
                    </div>
                    <div class="pricing-modern-price-period" contenteditable="true">
                      $ 834/yr
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      LIABILITY
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 4,55,000</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      PERSONAL PROPERTY
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 150,500</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      MEDICAL
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 1,600</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-footer-link" contenteditable="true">
                      FIND AN AGENT
                    </div>
                    <button class="pricing-modern-cta" contenteditable="true">
                      BUY
                    </button>
                  </div>

                  <div class="pricing-modern-card premium-green">
                    <div class="pricing-modern-plan-label" contenteditable="true">PREMIUM</div>
                    <div class="pricing-modern-price-main">
                      <span contenteditable="true">$</span><span contenteditable="true">82</span>
                    </div>
                    <div class="pricing-modern-price-period" contenteditable="true">
                      $ 979/yr
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      LIABILITY
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 1,43,000</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      PERSONAL PROPERTY
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 175,200</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-section-title" contenteditable="true">
                      MEDICAL
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">$ 1,900</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-footer-link" contenteditable="true">
                      FIND AN AGENT
                    </div>
                    <button class="pricing-modern-cta" contenteditable="true">
                      BUY
                    </button>
                  </div>
                </div>
              </div>
            `,
          },
          {
            title: 'Layout 6 – Pricing Cards Laranja',
            description: 'Variação em laranja do layout moderno',
            content: `
              <div class="layout-wrapper pricing-modern-bg-orange" style="background:#ffffff;">
                <div class="pricing-modern-wrapper" style="background:#ffffff;">
                  <div class="pricing-modern-card basic-orange">
                    <div class="pricing-modern-plan-label" contenteditable="true">BASIC</div>

                    <div class="pricing-modern-price-main">
                      <span contenteditable="true">$</span><span contenteditable="true">57</span>
                    </div>
                    <div class="pricing-modern-price-period" contenteditable="true">
                      $ 681/yr
                    </div>

                    <div class="pricing-modern-section-title" contenteditable="true">
                      BENEFIT GROUP 1
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Item 1</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>

                    <div class="pricing-modern-section-title" contenteditable="true">
                      BENEFIT GROUP 2
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Item 2</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>

                    <div class="pricing-modern-section-title" contenteditable="true">
                      BENEFIT GROUP 3
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Item 3</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>

                    <div class="pricing-modern-footer-link" contenteditable="true">
                      CALL TO ACTION
                    </div>

                    <button class="pricing-modern-cta" contenteditable="true">
                      BUY
                    </button>
                  </div>

                  <div class="pricing-modern-card standard-orange">
                    <div class="pricing-modern-plan-label" contenteditable="true">STANDARD</div>

                    <div class="pricing-modern-price-main">
                      <span contenteditable="true">$</span><span contenteditable="true">70</span>
                    </div>
                    <div class="pricing-modern-price-period" contenteditable="true">
                      $ 834/yr
                    </div>

                    <div class="pricing-modern-section-title" contenteditable="true">
                      BENEFIT GROUP 1
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Item 1</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>

                    <div class="pricing-modern-section-title" contenteditable="true">
                      BENEFIT GROUP 2
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Item 2</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>

                    <div class="pricing-modern-section-title" contenteditable="true">
                      BENEFIT GROUP 3
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Item 3</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>

                    <div class="pricing-modern-footer-link" contenteditable="true">
                      CALL TO ACTION
                    </div>

                    <button class="pricing-modern-cta" contenteditable="true">
                      BUY
                    </button>
                  </div>

                  <div class="pricing-modern-card premium-orange">
                    <div class="pricing-modern-plan-label" contenteditable="true">PREMIUM</div>

                    <div class="pricing-modern-price-main">
                      <span contenteditable="true">$</span><span contenteditable="true">82</span>
                    </div>
                    <div class="pricing-modern-price-period" contenteditable="true">
                      $ 979/yr
                    </div>

                    <div class="pricing-modern-section-title" contenteditable="true">
                      BENEFIT GROUP 1
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Item 1</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>

                    <div class="pricing-modern-section-title" contenteditable="true">
                      BENEFIT GROUP 2
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Item 2</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>

                    <div class="pricing-modern-section-title" contenteditable="true">
                      BENEFIT GROUP 3
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Item 3</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>

                    <div class="pricing-modern-footer-link" contenteditable="true">
                      CALL TO ACTION
                    </div>

                    <button class="pricing-modern-cta" contenteditable="true">
                      BUY
                    </button>
                  </div>

                </div>
              </div>
            `,
          },
          {
            title: 'Layout 7 – Pricing Cards Preto & Dourado',
            description: 'Variação em preto com dourado do layout moderno',
            content: `
              <div class="layout-wrapper pricing-modern-bg-blackgold" style="background:#ffffff;">
                <div class="pricing-modern-wrapper" style="background:#ffffff;">
                  <div class="pricing-modern-card basic-blackgold">
                    <div class="pricing-modern-plan-label" contenteditable="true">BASIC</div>

                    <div class="pricing-modern-price-main">
                      <span contenteditable="true">$</span><span contenteditable="true">57</span>
                    </div>
                    <div class="pricing-modern-price-period" contenteditable="true">
                      LIFETIME
                    </div>

                    <div class="pricing-modern-section-title" contenteditable="true">
                      BENEFITS
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Feature 1</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Feature 2</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Feature 3</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>

                    <div class="pricing-modern-footer-link" contenteditable="true">
                      MORE DETAILS
                    </div>

                    <button class="pricing-modern-cta" contenteditable="true">
                      BUY
                    </button>
                  </div>

                  <div class="pricing-modern-card standard-blackgold">
                    <div class="pricing-modern-plan-label" contenteditable="true">STANDARD</div>

                    <div class="pricing-modern-price-main">
                      <span contenteditable="true">$</span><span contenteditable="true">70</span>
                    </div>
                    <div class="pricing-modern-price-period" contenteditable="true">
                      PER MONTH
                    </div>

                    <div class="pricing-modern-section-title" contenteditable="true">
                      BENEFITS
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Feature 1</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Feature 2</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Feature 3</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>

                    <div class="pricing-modern-footer-link" contenteditable="true">
                      MORE DETAILS
                    </div>

                    <button class="pricing-modern-cta" contenteditable="true">
                      BUY
                    </button>
                  </div>

                  <div class="pricing-modern-card premium-blackgold">
                    <div class="pricing-modern-plan-label" contenteditable="true">PREMIUM</div>

                    <div class="pricing-modern-price-main">
                      <span contenteditable="true">$</span><span contenteditable="true">99</span>
                    </div>
                    <div class="pricing-modern-price-period" contenteditable="true">
                      PER MONTH
                    </div>

                    <div class="pricing-modern-section-title" contenteditable="true">
                      BENEFITS
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Feature 1</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Feature 2</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>
                    <div class="pricing-modern-item">
                      <span class="pricing-modern-item-label" contenteditable="true">Feature 3</span>
                      <div class="pricing-modern-controls">
                        <span>−</span><span>+</span>
                      </div>
                    </div>

                    <div class="pricing-modern-footer-link" contenteditable="true">
                      MORE DETAILS
                    </div>

                    <button class="pricing-modern-cta" contenteditable="true">
                      BUY
                    </button>
                  </div>

                </div>
              </div>
            `,
          },
          {
            title: 'Layout 8 – Select Your Plan (Azul)',
            description: '3 cards com cabeçalho “SELECT YOUR PLAN”, variação azul, sem degradê de fundo',
            content: `
              <div class="layout-wrapper select-plan-section select-plan-blue" style="background:#ffffff;">
                <div class="select-plan-title" contenteditable="true">SELECT YOUR PLAN</div>

                <div class="select-plan-grid" style="background:#ffffff;">
                  <div class="select-plan-card">
                    <div class="select-plan-card-header" contenteditable="true">FREE</div>

                    <div class="select-plan-price-main">
                      <span class="select-plan-price-currency" contenteditable="true">€</span>
                      <span contenteditable="true">0</span>
                    </div>
                    <div class="select-plan-price-period" contenteditable="true">LIFETIME</div>

                    <ul class="select-plan-features">
                      <li contenteditable="true">One user</li>
                      <li contenteditable="true">1000 UI elements</li>
                      <li contenteditable="true">E-mail support</li>
                    </ul>

                    <button class="select-plan-cta" contenteditable="true">Sign up</button>
                  </div>

                  <div class="select-plan-card">
                    <div class="select-plan-card-header" contenteditable="true">PRO</div>

                    <div class="select-plan-price-main">
                      <span class="select-plan-price-currency" contenteditable="true">€</span>
                      <span contenteditable="true">49</span>
                    </div>
                    <div class="select-plan-price-period" contenteditable="true">PER MONTH</div>

                    <ul class="select-plan-features">
                      <li contenteditable="true">Up to 10 users</li>
                      <li contenteditable="true">10 000 UI elements</li>
                      <li contenteditable="true">Phone support</li>
                      <li contenteditable="true">Analytics</li>
                    </ul>

                    <button class="select-plan-cta" contenteditable="true">Sign up</button>
                  </div>

                  <div class="select-plan-card">
                    <div class="select-plan-card-header" contenteditable="true">TEAM</div>

                    <div class="select-plan-price-main">
                      <span class="select-plan-price-currency" contenteditable="true">€</span>
                      <span contenteditable="true">72</span>
                    </div>
                    <div class="select-plan-price-period" contenteditable="true">PER MONTH</div>

                    <ul class="select-plan-features">
                      <li contenteditable="true">Up to 100 users</li>
                      <li contenteditable="true">10 000 UI elements</li>
                      <li contenteditable="true">Phone support</li>
                      <li contenteditable="true">Analytics</li>
                    </ul>

                    <button class="select-plan-cta" contenteditable="true">Sign up</button>
                  </div>
                </div>
              </div>
            `,
          },
          {
            title: 'Layout 9 – Select Your Plan (Verde)',
            description: 'Mesma estrutura do layout 8, porém em verde',
            content: `
              <div class="layout-wrapper select-plan-section select-plan-green" style="background:#ffffff;">
                <div class="select-plan-title" contenteditable="true">SELECT YOUR PLAN</div>

                <div class="select-plan-grid" style="background:#ffffff;">
                  <div class="select-plan-card">
                    <div class="select-plan-card-header" contenteditable="true">FREE</div>

                    <div class="select-plan-price-main">
                      <span class="select-plan-price-currency" contenteditable="true">€</span>
                      <span contenteditable="true">0</span>
                    </div>
                    <div class="select-plan-price-period" contenteditable="true">LIFETIME</div>

                    <ul class="select-plan-features">
                      <li contenteditable="true">One user</li>
                      <li contenteditable="true">1000 UI elements</li>
                      <li contenteditable="true">E-mail support</li>
                    </ul>

                    <button class="select-plan-cta" contenteditable="true">Sign up</button>
                  </div>

                  <div class="select-plan-card">
                    <div class="select-plan-card-header" contenteditable="true">PRO</div>

                    <div class="select-plan-price-main">
                      <span class="select-plan-price-currency" contenteditable="true">€</span>
                      <span contenteditable="true">49</span>
                    </div>
                    <div class="select-plan-price-period" contenteditable="true">PER MONTH</div>

                    <ul class="select-plan-features">
                      <li contenteditable="true">Up to 10 users</li>
                      <li contenteditable="true">10 000 UI elements</li>
                      <li contenteditable="true">Phone support</li>
                      <li contenteditable="true">Analytics</li>
                    </ul>

                    <button class="select-plan-cta" contenteditable="true">Sign up</button>
                  </div>

                  <div class="select-plan-card">
                    <div class="select-plan-card-header" contenteditable="true">TEAM</div>

                    <div class="select-plan-price-main">
                      <span class="select-plan-price-currency" contenteditable="true">€</span>
                      <span contenteditable="true">72</span>
                    </div>
                    <div class="select-plan-price-period" contenteditable="true">PER MONTH</div>

                    <ul class="select-plan-features">
                      <li contenteditable="true">Up to 100 users</li>
                      <li contenteditable="true">10 000 UI elements</li>
                      <li contenteditable="true">Phone support</li>
                      <li contenteditable="true">Analytics</li>
                    </ul>

                    <button class="select-plan-cta" contenteditable="true">Sign up</button>
                  </div>
                </div>
              </div>
            `,
          },
        ],
      },
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    // DOCX
    handleDocxUpload(event) {
      const file = event.target.files[0]
      if (!file) return

      const input = event.target
      input.value = null

      const reader = new FileReader()

      reader.onload = loadEvent => {
        const arrayBuffer = loadEvent.target.result

        mammoth.convertToHtml({ arrayBuffer })
          .then(result => {
            const html = result.value
            const { editor } = this.$refs.tinymceEditor
            if (editor) {
              editor.setContent(html)
            }
          })
          .catch(() => {
            this.$erro('Falha na conversão do arquivo .docx.')
          })
      }

      reader.readAsArrayBuffer(file)
    },

    handlePdfUpload(event) {
      const input = event?.target
      const file = input?.files?.[0]
      if (!file) return

      // limpa o input para permitir selecionar o mesmo arquivo novamente
      if (input) input.value = ''

      // guarda o arquivo para envio posterior (FormData em salvar())
      this.pdfFile = file

      if (typeof this.$sucesso === 'function') {
        this.$sucesso('PDF anexado à proposta. Ele será enviado junto ao template.')
      }
    },

    carregar(id) {
      api.getTemplateById(id)
        .then(payload => {
          this.form = payload.data
        })
        .catch(err => {
          throw err
        })
    },
    cancelar() {
      this.$router.go(-1)
    },
    salvar() {
      return new Promise((resolve, reject) => {
        if (this.$refs.tinymceEditor && this.$refs.tinymceEditor.editor) {
          this.form.template = this.$refs.tinymceEditor.editor.getContent()
        }
        // Remove caracteres invisíveis
        this.form.template = this.form.template.replace(/[\u200B-\u200D\uFEFF]/g, '')

        // Monta FormData com todos os campos do form e, se existir, o PDF
        const formData = new FormData()
        Object.keys(this.form).forEach(key => {
          const val = this.form[key]
          if (val === undefined || val === null) return
          if (typeof val === 'object' && !(val instanceof File)) {
            formData.append(key, JSON.stringify(val))
          } else {
            formData.append(key, val)
          }
        })

        if (this.pdfFile) {
          // Campo 'pdfApresentacaoUpload' — ajustar se o backend esperar outro nome
          formData.append('pdfApresentacaoUpload', this.pdfFile)
        }

        if (this.state === 'novo') {
          api.salvarTemplate(formData)
            .then(() => {
              this.pdfFile = null
              this.$router.go(-1)
              resolve('Template cadastrado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateTemplate(this.form.id, formData)
            .then(() => {
              this.pdfFile = null
              this.$router.go(-1)
              resolve('Template alterado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    addTagTemplate(value) {
      if (value.includes('{Assinatura Assinatura Responsável}') || value.includes('{Assinatura Assinatura Testemunha}')) {
        this.tagAtual = value
        if (!this.usuarios || this.usuarios.length === 0) {
          apiUsuarioInterno.getUsuariosMarcacaoDocuSign()
            .then(payload => {
              this.usuarios = payload.data
              this.usuariosFiltrado = value.includes('Responsável')
                ? this.usuarios.filter(fil => fil.docuSignResponsavel)
                : this.usuarios.filter(fil => fil.docuSignTestemunha)
              this.$refs.modalUsuarioDocusign.show()
            })
        } else {
          this.usuariosFiltrado = value.includes('Responsável')
            ? this.usuarios.filter(fil => fil.docuSignResponsavel)
            : this.usuarios.filter(fil => fil.docuSignTestemunha)
          this.$refs.modalUsuarioDocusign.show()
        }
      } else {
        const { editor } = this.$refs.tinymceEditor
        if (editor) {
          editor.insertContent(`<strong>{${value}}</strong>&nbsp;`)
        }
      }
    },
    setUsuarioTag() {
      const usuario = this.usuarios.find(find => find.id === this.selecionado)
      const { editor } = this.$refs.tinymceEditor
      const tag = this.tagAtual.replace('}', ` ${usuario.id} - ${usuario.nomeCompleto}}`)
      if (editor) {
        editor.insertContent(`<strong>${tag}</strong>&nbsp;`)
      }

      this.selecionado = null
      this.$refs.modalUsuarioDocusign.hide()
    },
    imprimir() {
      const winPrint = window.open('', '', 'left=0,top=0,bottom=100,width=800,height=900,toolbar=0,scrollbars=0,status=0')

      const conteudoEditor = this.$refs.tinymceEditor && this.$refs.tinymceEditor.editor
        ? this.$refs.tinymceEditor.editor.getContent()
        : this.form.contrato

      if (conteudoEditor) {
        winPrint.document.write(`<!DOCTYPE html>
        <html xmlns="http://www.w3.org/1999/xhtml">
          <head>
              <title>Print Proposta</title>
              <style>
                @page {
                  size: auto;
                  margin: 0mm;
                }

                html {
                  background-color: #FFFFFF;
                  margin: 0px;
                }

                body {
                  border: solid 1px white;
                  margin: 10mm 15mm 10mm 15mm;
                  font-family: Arial, sans-serif;
                  background: #ffffff;
                }

                .layout-wrapper {
                  padding: 40px 20px;
                  box-sizing: border-box;
                  background: #ffffff;
                }

                /* ====== Layouts 1 e 2 – A4 (fundo branco) ====== */

                .a4-page {
                  background: #ffffff;
                  margin: 0 auto;
                  padding: 24px;
                  box-sizing: border-box;
                }

                .a4-vertical {
                  width: 210mm;
                  min-height: 297mm;
                }

                .a4-horizontal {
                  width: 297mm;
                  min-height: 210mm;
                }

                .a4-page .pricing-layout {
                  display: flex;
                  flex-direction: column;
                  gap: 16px;
                }

                @media print {
                  .a4-page .pricing-layout {
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: stretch;
                  }
                }

                .a4-page .pricing-card {
                  flex: 1;
                  max-width: 32%;
                  background: #ffffff;
                  border-radius: 20px;
                  padding: 18px 16px 22px;
                  color: #1f2544;
                  box-sizing: border-box;
                  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.12);
                }

                .a4-page .pricing-card-inner {
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                }

                .a4-page .pricing-card.highlight {
                  background: linear-gradient(160deg, #4c6fff, #9f66ff);
                  color: #ffffff;
                  transform: translateY(-4px);
                }

                .a4-page .pricing-card-header {
                  display: flex;
                  justify-content: space-between;
                  align-items: flex-start;
                  gap: 8px;
                  margin-bottom: 12px;
                }

                .a4-page .pricing-card-header-left {
                  display: flex;
                  flex-direction: column;
                  gap: 4px;
                }

                .a4-page .pricing-card-icon {
                  font-size: 20px;
                  margin-bottom: 2px;
                }

                .a4-page .pricing-card-title {
                  font-size: 16px;
                  font-weight: 700;
                  margin: 0;
                }

                .a4-page .pricing-card-subtitle {
                  font-size: 11px;
                  opacity: 0.8;
                }

                .a4-page .pricing-card-rate-block {
                  text-align: right;
                }

                .a4-page .pricing-card-rate {
                  font-size: 20px;
                  font-weight: 700;
                }

                .a4-page .pricing-card-rate-period {
                  font-size: 11px;
                  opacity: 0.8;
                }

                .a4-page .pricing-card-benefits {
                  list-style: none;
                  padding: 0;
                  margin: 10px 0 14px;
                  font-size: 11px;
                  flex: 1;
                }

                .a4-page .pricing-card-benefits li {
                  display: flex;
                  align-items: flex-start;
                  gap: 6px;
                  margin-bottom: 4px;
                }

                .a4-page .pricing-card-check-icon {
                  width: 10px;
                  height: 10px;
                  margin-top: 3px;
                  border-radius: 50%;
                  border: 1px solid currentColor;
                }

                .a4-page .pricing-card-divider {
                  height: 3px;
                  width: 40%;
                  border-radius: 999px;
                  background: rgba(148, 163, 184, 0.6);
                  margin-top: 6px;
                }

                .a4-page .pricing-card.highlight .pricing-card-divider {
                  background: rgba(255, 255, 255, 0.7);
                }

                /* ===== Layout 3 – Cards Fogo Azul ===== */

                .pricing-fire-wrapper {
                  max-width: 900px;
                  margin: 0 auto;
                  padding: 40px 20px;
                  box-sizing: border-box;
                  display: flex;
                  flex-wrap: wrap;
                  gap: 24px;
                  justify-content: center;
                  font-family: Arial, sans-serif;
                  background: #ffffff;
                }

                .fire-card {
                  flex: 1 1 260px;
                  max-width: 300px;
                  border-radius: 26px;
                  padding: 22px 20px 24px;
                  background: #07132b;
                  color: #e5edff;
                  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.45);
                  display: flex;
                  flex-direction: column;
                }

                .fire-card.highlight {
                  background: linear-gradient(145deg, #2563eb, #4f46e5);
                }

                .fire-card-header {
                  display: flex;
                  justify-content: space-between;
                  align-items: flex-start;
                  gap: 12px;
                  margin-bottom: 16px;
                }

                .fire-card-header-left {
                  display: flex;
                  flex-direction: column;
                  gap: 6px;
                }

                .fire-card-logo {
                  width: 32px;
                  height: 32px;
                  border-radius: 50%;
                  background: radial-gradient(circle at 30% 20%, #f97316, #ef4444);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 16px;
                }

                .fire-card-plan {
                  font-size: 11px;
                  letter-spacing: 1.8px;
                  text-transform: uppercase;
                  opacity: 0.8;
                }

                .fire-card-title {
                  font-size: 16px;
                  font-weight: 700;
                }

                .fire-card-price {
                  text-align: right;
                  font-size: 28px;
                  font-weight: 700;
                }

                .fire-card-price span {
                  display: block;
                  font-size: 11px;
                  opacity: 0.75;
                }

                .fire-card-benefits {
                  list-style: none;
                  padding: 0;
                  margin: 10px 0 0;
                  font-size: 12px;
                }

                .fire-card-benefits li {
                  display: flex;
                  gap: 8px;
                  align-items: flex-start;
                  margin-bottom: 6px;
                }

                .fire-card-check {
                  width: 12px;
                  height: 12px;
                  border-radius: 50%;
                  border: 2px solid #22c55e;
                  margin-top: 2px;
                  position: relative;
                }

                .fire-card-check::after {
                  content: '';
                  position: absolute;
                  left: 2px;
                  top: 3px;
                  width: 6px;
                  height: 3px;
                  border-left: 2px solid #22c55e;
                  border-bottom: 2px solid #22c55e;
                  transform: rotate(-45deg);
                }

                .fire-card-footer {
                  margin-top: 14px;
                  font-size: 11px;
                  opacity: 0.8;
                  text-transform: uppercase;
                  letter-spacing: 1.5px;
                }

                /* ====== Layouts 4–7 – Modern Pricing (fundo externo branco) ====== */

                .pricing-modern-bg,
                .pricing-modern-bg-green,
                .pricing-modern-bg-orange,
                .pricing-modern-bg-blackgold {
                  background: #ffffff;
                }

                .pricing-modern-wrapper {
                  max-width: 960px;
                  margin: 0 auto;
                  padding: 40px 20px;
                  box-sizing: border-box;
                  display: flex;
                  gap: 24px;
                  justify-content: center;
                  flex-wrap: wrap;
                  font-family: Arial, sans-serif;
                  background: #ffffff;
                }

                .pricing-modern-card {
                  flex: 1 1 260px;
                  max-width: 300px;
                  border-radius: 30px;
                  padding: 26px 22px 28px;
                  box-sizing: border-box;
                  color: #ffffff;
                  display: flex;
                  flex-direction: column;
                  position: relative;
                  overflow: hidden;
                }

                .pricing-modern-card.basic-blue {
                  background: #fdfdfd;
                  color: #1b2140;
                  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.25);
                }

                .pricing-modern-card.standard-blue {
                  background: #346dff;
                  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
                }

                .pricing-modern-card.premium-blue {
                  background: #061a3a;
                  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.4);
                }

                .pricing-modern-card.basic-green {
                  background: #fdfdfd;
                  color: #0f261e;
                  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.25);
                }

                .pricing-modern-card.standard-green {
                  background: #25b574;
                  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
                }

                .pricing-modern-card.premium-green {
                  background: #043326;
                  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.4);
                }

                .pricing-modern-card.basic-orange {
                  background: #fdfdfd;
                  color: #3b1f0a;
                  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.25);
                }

                .pricing-modern-card.standard-orange {
                  background: #fb923c;
                  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
                }

                .pricing-modern-card.premium-orange {
                  background: #7c2d12;
                  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.4);
                }

                .pricing-modern-card.basic-blackgold {
                  background: #fefce8;
                  color: #1f2933;
                  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.25);
                }

                .pricing-modern-card.standard-blackgold {
                  background: #facc15;
                  color: #1f2933;
                  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
                }

                .pricing-modern-card.premium-blackgold {
                  background: #020617;
                  color: #facc15;
                  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.4);
                }

                .pricing-modern-plan-label {
                  font-size: 11px;
                  font-weight: 600;
                  letter-spacing: 2px;
                  text-transform: uppercase;
                  margin-bottom: 20px;
                }

                .pricing-modern-price-main {
                  font-size: 40px;
                  font-weight: 700;
                  line-height: 1;
                }

                .pricing-modern-price-main span {
                  font-size: 22px;
                  font-weight: 600;
                  vertical-align: top;
                  margin-right: 4px;
                }

                .pricing-modern-price-period {
                  font-size: 12px;
                  opacity: 0.75;
                  margin-top: 4px;
                }

                .pricing-modern-section-title {
                  font-size: 11px;
                  text-transform: uppercase;
                  letter-spacing: 1.5px;
                  opacity: 0.8;
                  margin-top: 20px;
                  margin-bottom: 6px;
                }

                .pricing-modern-item {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  font-size: 12px;
                  padding: 6px 0;
                  border-top: 1px solid rgba(255, 255, 255, 0.1);
                }

                .pricing-modern-item:last-child {
                  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                }

                .pricing-modern-card.basic-blue .pricing-modern-item,
                .pricing-modern-card.basic-green .pricing-modern-item,
                .pricing-modern-card.basic-orange .pricing-modern-item,
                .pricing-modern-card.basic-blackgold .pricing-modern-item {
                  border-top: 1px solid rgba(15, 23, 42, 0.08);
                }

                .pricing-modern-card.basic-blue .pricing-modern-item:last-child,
                .pricing-modern-card.basic-green .pricing-modern-item:last-child,
                .pricing-modern-card.basic-orange .pricing-modern-item:last-child,
                .pricing-modern-card.basic-blackgold .pricing-modern-item:last-child {
                  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
                }

                .pricing-modern-item-label {
                  opacity: 0.85;
                }

                .pricing-modern-controls {
                  display: flex;
                  gap: 6px;
                  font-size: 10px;
                  opacity: 0.7;
                }

                .pricing-modern-controls span {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 18px;
                  height: 18px;
                  border-radius: 50%;
                  border: 1px solid currentColor;
                }

                .pricing-modern-footer-link {
                  margin-top: 18px;
                  font-size: 11px;
                  text-transform: uppercase;
                  letter-spacing: 1.5px;
                  opacity: 0.8;
                }

                .pricing-modern-cta {
                  margin-top: 12px;
                  align-self: flex-start;
                  padding: 10px 28px;
                  border-radius: 999px;
                  border: none;
                  font-size: 12px;
                  font-weight: 600;
                  cursor: default;
                  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
                }

                .basic-blue .pricing-modern-cta,
                .premium-blue .pricing-modern-cta {
                  background: #4f6bff;
                  color: #ffffff;
                }

                .standard-blue .pricing-modern-cta {
                  background: #ffffff;
                  color: #2146c6;
                }

                .basic-green .pricing-modern-cta,
                .premium-green .pricing-modern-cta {
                  background: #23b16e;
                  color: #ffffff;
                }

                .standard-green .pricing-modern-cta {
                  background: #ffffff;
                  color: #128a52;
                }

                .basic-orange .pricing-modern-cta,
                .premium-orange .pricing-modern-cta {
                  background: #ea580c;
                  color: #ffffff;
                }

                .standard-orange .pricing-modern-cta {
                  background: #ffffff;
                  color: #c2410c;
                }

                .basic-blackgold .pricing-modern-cta,
                .premium-blackgold .pricing-modern-cta {
                  background: #facc15;
                  color: #1f2933;
                }

                .standard-blackgold .pricing-modern-cta {
                  background: #1f2933;
                  color: #facc15;
                }

                /* ====== Layouts 8 e 9 – Select Your Plan (fundo branco) ====== */

                .select-plan-section {
                  padding: 40px 20px 50px;
                  box-sizing: border-box;
                  background: #ffffff;
                  font-family: Arial, sans-serif;
                }

                .select-plan-title {
                  text-align: center;
                  font-size: 24px;
                  font-weight: 700;
                  margin-bottom: 32px;
                  letter-spacing: 2px;
                }

                .select-plan-blue .select-plan-title {
                  color: #1f5fff;
                }

                .select-plan-green .select-plan-title {
                  color: #16a34a;
                }

                .select-plan-grid {
                  max-width: 960px;
                  margin: 0 auto;
                  display: flex;
                  flex-wrap: wrap;
                  gap: 24px;
                  justify-content: center;
                  background: #ffffff;
                }

                .select-plan-card {
                  flex: 1 1 260px;
                  max-width: 300px;
                  background: #ffffff;
                  border-radius: 18px;
                  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.15);
                  padding: 26px 22px 28px;
                  box-sizing: border-box;
                  text-align: center;
                }

                .select-plan-card-header {
                  text-transform: uppercase;
                  font-size: 11px;
                  letter-spacing: 1.6px;
                  font-weight: 600;
                  margin-bottom: 18px;
                }

                .select-plan-blue .select-plan-card-header {
                  color: #1f5fff;
                }

                .select-plan-green .select-plan-card-header {
                  color: #16a34a;
                }

                .select-plan-price-main {
                  font-size: 40px;
                  font-weight: 700;
                  margin-bottom: 4px;
                }

                .select-plan-price-currency {
                  font-size: 20px;
                  vertical-align: top;
                  margin-right: 4px;
                }

                .select-plan-price-period {
                  font-size: 11px;
                  text-transform: uppercase;
                  opacity: 0.7;
                  margin-bottom: 18px;
                }

                .select-plan-features {
                  list-style: none;
                  padding: 0;
                  margin: 0 0 22px;
                  font-size: 12px;
                  text-align: left;
                }

                .select-plan-features li {
                  margin-bottom: 6px;
                }

                .select-plan-features li::before {
                  content: "– ";
                }

                .select-plan-cta {
                  margin-top: 8px;
                  display: inline-block;
                  padding: 10px 30px;
                  border-radius: 999px;
                  border: none;
                  font-size: 12px;
                  font-weight: 600;
                  cursor: default;
                }

                .select-plan-blue .select-plan-cta {
                  background: #1f5fff;
                  color: #ffffff;
                }

                .select-plan-green .select-plan-cta {
                  background: #16a34a;
                  color: #ffffff;
                }
              </style>
          </head>
          <body>
            <div>
              ${conteudoEditor}
            </div>
          </body>
        </html>`)
      }

      winPrint.document.close()
      winPrint.focus()
      winPrint.print()
      winPrint.close()
    },
    alterandoAba(newIndex) {
      this.abaAcessada = newIndex
    },
  },
}
</script>
